import { render } from "./LocaleChanger.vue?vue&type=template&id=5e64e2c4"
import script from "./LocaleChanger.vue?vue&type=script&lang=js"
export * from "./LocaleChanger.vue?vue&type=script&lang=js"

import "./LocaleChanger.vue?vue&type=style&index=0&id=5e64e2c4&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__